import { Node } from '@tiptap/core';

export default Node.create({
  name: 'iframe',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      frameborder: {
        default: 0,
      },
      allow: {
        default: null,
      },
      allowfullscreen: {
        default: null,
        parseHTML: element => element.hasAttribute('allowfullscreen'),
        renderHTML: attributes => {
          if (attributes.allowfullscreen) {
            return { allowfullscreen: '' };
          }
          return {};
        },
      },
      referrerpolicy: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: null,
      },
      height: {
        default: null,
      },
      class: {
        default: null,
      },
      style: {
        default: null,
      },
      sandbox: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['iframe', HTMLAttributes];
  },

  addCommands() {
    return {
      setIframe: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        });
      },
    };
  },
});
